import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './../store/index'
import i18n from '../i18n'

Vue.use(VueRouter)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next();
    return;
  }
    next(`/${i18n.locale}/categories`);
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
    return;
  }
    next('/account/login');
}

const routes = [
  {
    path: '/', redirect: `/${i18n.locale}/account/login`,
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/:lang',
    component:{
      render (c) {return c('router-view')}
    },
      children: [
        {
          path: 'account/login',
          name: 'login',
          beforeEnter: ifNotAuthenticated,
          component: () => import(/* webpackChunkName: "login" */ '../components/auth/LoginForm.vue')
        },
      ]
  },
  {
    path: `/${i18n.locale}/dashboard`,
    meta: {
      name: 'Dashboard View',
      requiresAuth: true
    },
    component: () => import(`@/components/Dashboard.vue`),
    children: [
      {
        path: `/${i18n.locale}/categories`,
        meta: {
          name: 'Categories',
          requiresAuth: true
        },
        component: () => import(`@/components/dashboardViews/Categories.vue`)
      },
      {
        path: `/${i18n.locale}/categories/add-new-category`,
        meta: {
          name: 'New category',
          requiresAuth: true
        },
        component: () => import(`@/components/dashboardViews/NewCategory.vue`)
      },
      {
        path: `/${i18n.locale}/categories/edit-category/:id`,
        meta: {
          name: 'Edit category',
          requiresAuth: true
        },
        component: () => import(`@/components/dashboardViews/EditCategory.vue`)
      },
      {
        path: `/${i18n.locale}/categories/subcategories/add-new-subcategory`,
        meta: {
          name: 'New subcategory',
          requiresAuth: true
        },
        component: () => import(`@/components/dashboardViews/NewSubcategory.vue`)
      },
      {
        path: `/${i18n.locale}/subcategories/:name`,
        props: true,
        meta: {
          name: 'Subcategories',
          requiresAuth: true
        },
        component: () => import(`@/components/dashboardViews/Subcategories.vue`)
      },
      {
        path: `/${i18n.locale}/categories/subcategories/edit-subcategory/:id`,
        meta: {
          name: 'Edit subcategory',
          requiresAuth: true
        },
        component: () => import(`@/components/dashboardViews/EditSubcategory.vue`)
      },
      {
        path: `/${i18n.locale}/products`,
        props: true,
        meta: {
          name: 'Products',
          requiresAuth: true
        },
        component: () => import(`@/components/dashboardViews/Products.vue`)
      },
      {
        path: `/${i18n.locale}/products/add-new-product`,
        meta: {
          name: 'New product',
          requiresAuth: true
        },
        component: () => import(`@/components/dashboardViews/NewProduct.vue`)
      },
      {
        path: `/${i18n.locale}/products/edit-product/:id`,
        meta: {
          name: 'Edit product',
          requiresAuth: true
        },
        component: () => import(`@/components/dashboardViews/EditProduct.vue`)
      },
      {
        path: `/${i18n.locale}/mobile-layout`,
        meta: {
          name: 'Mobile',
          requiresAuth: true
        },
        component: () => import(`@/components/dashboardViews/MobileLayout.vue`)
      },
      {
        path: `/${i18n.locale}/design/add-new-design`,
        meta: {
          name: 'New design',
          requiresAuth: true
        },
        component: () => import(`@/components/dashboardViews/ProductDesign.vue`)
      },
      {
        path: `/${i18n.locale}/design/edit-design/:id`,
        meta: {
          name: 'Edit design',
          requiresAuth: true
        },
        component: () => import(`@/components/dashboardViews/ProductDesign.vue`)
      },
      {
        path: `/${i18n.locale}/users`,
        meta: {
          name: 'Users',
          requiresAuth: true
        },
        component: () => import(`@/components/dashboardViews/Users.vue`)
      },
      {
        path: `/${i18n.locale}/orders`,
        meta: {
          name: 'Orders',
          requiresAuth: true
        },
        component: () => import(`@/components/dashboardViews/Orders.vue`)
      },
      {
        path: `/${i18n.locale}/page-not-found`,
        name: 'Page not found',
         requiresAuth: true,
        component: () => import(`@/components/PageNotFound.vue`)
      }
    ]
  },
  { path: '/*',
    beforeEnter: ifAuthenticated || ifNotAuthenticated,
    component: () => import('../components/PageNotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
